export enum DirectSalesAllocationSolutionStatus {
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
}
